import React from 'react';

export default function SheetSelector({ sheetNames, currentSheet, onSheetChange }) {
  if (!sheetNames || sheetNames.length === 0) return null;
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
      {sheetNames.map((name, idx) => (
        <button
          key={name}
          onClick={() => onSheetChange(idx)}
          style={{
            padding: '4px 14px',
            borderRadius: 6,
            border: idx === currentSheet ? '2px solid #2563eb' : '1px solid #e5e7eb',
            background: idx === currentSheet ? '#2563eb' : '#f1f5f9',
            color: idx === currentSheet ? 'white' : '#334155',
            fontWeight: 600,
            cursor: 'pointer',
            fontSize: 15,
            outline: 'none',
            transition: 'all 0.15s',
          }}
        >
          {name}
        </button>
      ))}
    </div>
  );
} 